// ADR-0152 (#0748) — avisos y guías de mantención por proyecto (core-api
// /asset-groups/:id/announcements/*). Publicar con adjunto es presign →
// PUT directo al bucket → publicar; core-api re-verifica el objeto (existe,
// es PDF, pesa lo permitido). Un aviso publicado no se edita: se retira.

import {
  announcementAttachmentUploadUrlResponseSchema,
  announcementAttachmentUrlResponseSchema,
  announcementListResponseSchema,
  announcementSchema,
  type Announcement,
  type AnnouncementAttachmentUploadUrlRequest,
  type AnnouncementAttachmentUploadUrlResponse,
  type AnnouncementAttachmentUrlResponse,
  type AnnouncementCreateRequest,
  type AnnouncementListResponse,
} from "@bitacorapro/api-types";
import { request } from "../client";

const base = (groupId: string) => `/asset-groups/${encodeURIComponent(groupId)}/announcements`;

export const announcementsApi = {
  list: async (groupId: string): Promise<AnnouncementListResponse> => {
    const json = await request<unknown>("GET", "core", base(groupId));
    return announcementListResponseSchema.parse(json);
  },
  attachmentUploadUrl: async (
    groupId: string,
    body: AnnouncementAttachmentUploadUrlRequest
  ): Promise<AnnouncementAttachmentUploadUrlResponse> => {
    const json = await request<unknown>("POST", "core", `${base(groupId)}/attachment-upload-url`, {
      body,
    });
    return announcementAttachmentUploadUrlResponseSchema.parse(json);
  },
  // `idempotencyKey` obligatorio: publicar le escribe a todo el proyecto.
  // La pantalla la mantiene estable por intento (mismo contenido), así un
  // reintento tras perder la respuesta recibe el mismo aviso.
  create: async (
    groupId: string,
    body: AnnouncementCreateRequest,
    idempotencyKey: string
  ): Promise<Announcement> => {
    const json = await request<unknown>("POST", "core", base(groupId), {
      body,
      headers: { "Idempotency-Key": idempotencyKey },
    });
    return announcementSchema.parse(json);
  },
  retract: async (groupId: string, id: string): Promise<Announcement> => {
    const json = await request<unknown>(
      "POST",
      "core",
      `${base(groupId)}/${encodeURIComponent(id)}/retract`
    );
    return announcementSchema.parse(json);
  },
  cancel: async (groupId: string, id: string): Promise<Announcement> => {
    const json = await request<unknown>(
      "POST",
      "core",
      `${base(groupId)}/${encodeURIComponent(id)}/cancel`
    );
    return announcementSchema.parse(json);
  },
  attachmentUrl: async (
    groupId: string,
    id: string
  ): Promise<AnnouncementAttachmentUrlResponse> => {
    const json = await request<unknown>(
      "GET",
      "core",
      `${base(groupId)}/${encodeURIComponent(id)}/attachment-url`
    );
    return announcementAttachmentUrlResponseSchema.parse(json);
  },
};
